import { EstadosContratoChoiceEnum } from '@/shared';

export const calcContractStateColor = (
  contractState: EstadosContratoChoiceEnum
) => {
  if (!contractState) return 'default';

  return contractState === EstadosContratoChoiceEnum.ACTIVO
    ? 'success'
    : contractState === EstadosContratoChoiceEnum.SUSPENDIDO
    ? 'warning'
    : contractState === EstadosContratoChoiceEnum.RETENCION
    ? 'info'
    : contractState === EstadosContratoChoiceEnum.CANCELADO
    ? 'error'
    : 'info';
};
